// extracted by mini-css-extract-plugin
module.exports = {"Quid":"Quid_Quid__hlwt8","quidOpen":"Quid_quidOpen__3ve7g","close":"Quid_close__4lCGJ","mode":"Quid_mode__1j7Nr","quit":"Quid_quit__1J5Fn","triangle":"Quid_triangle__21v-i"};